import React, { Component } from 'react';
import styled from 'styled-components';
import classnames from 'classnames';

import colors from '../../../utils/colors';
import {media} from '../../../utils/uiSizes';

export const AccordionHeader = styled.div`

  svg {
    margin-right: .25em;
    cursor: pointer;
  }
  svg.open {
    display: none;
  }
  svg.closed {
    display: initial;
  }

  .open > & {
    svg.open {
      display: initial;
    }
    svg.closed {
      display: none;
    }
  }
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 0.875rem;
  &:first-child {
    margin-top: 0.875rem;
  }
  box-sizing: border-box;
`;

const Wrapper = styled.div`

  h2, h3, h4 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > .title {
      width: 100%;
    }
  }

  h4 {
    font-family: FyranSans-SemiBold;
    font-weight: bold;
    font-size: 1.125rem;
  }

  > header {
    &:not(.toggleDisabled) {
      cursor: pointer;
    }
  }

  .action-wrap {
    width: 20%;
		padding: 0 0.75rem 0 0;
    font-family: "FyranSans-Core";
    font-size: 1.125rem;
    flex-shrink: 0;
    box-sizing: border-box;

    > span {
      color: ${colors.GRAY_LIGHT};
    }
  }

  .toggleDisabled {
    svg {
      display: none !important;
    }
    h2, h3, h4 {
      padding-left: 1.5rem;
    }
  }

  table {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  ${props => props.Container && `
    > ${props.Container} {
      padding-left: 1.5rem;
    }
  `}

  &.channel {
    border-top: 0.625rem solid ${colors.GRAY_LIGHT};
    margin: 4rem -1.5rem 0;
    padding: 1rem 1.25rem 0;
    ${media.tablet `
      margin: 4rem -3rem 0;
      padding: 1rem 2.5rem 0;
    `}

    .region {
      margin: 0 -1.25rem 0 -2.75rem;
      padding: 1rem 1.25rem;
      ${media.tablet `
        margin: 0 -2.5rem 0 -4rem;
        padding: 1rem 2.5rem;
      `}
    }
  }

  &.region {
    padding-top: 1rem;
    padding-bottom: 1rem;

    margin: 0 -1.5rem;
    padding: 1rem 1.25rem;
    ${media.tablet `
      margin: 0 -3rem;
      padding: 1rem 2.5rem;
    `}

    &:first-of-type {
      border-top: 1px solid ${colors.GRAY_LIGHT};
    }
    &:not(:last-child) {
      border-bottom: 1px solid ${colors.GRAY_LIGHT};
    }

    .team {
      margin: 0 -2.5rem 0 -4rem;
      padding: 0rem 2.5rem;
    }
  }

  &.team {

  }
/*
  margin: 4rem -1.5rem 0;
  padding: 1rem 1.5rem 0;
  ${media.tablet`
    margin: 4rem -3rem 0;
    padding: 1rem 3rem 0;
  `}
*/
  ${props => props.Container && `
    & > ${props.Container} {
      display: none;
    }
  `}

  &.open {
    ${props => props.Container && `
      & > ${props.Container} {
        display: block;
      }
    `}
  }
  /*
  ${props => props.Container && `
    & > ${props.Container} {
      padding-left: 1.5rem;
      .accordion {
  //      margin-left: -1.5rem;
  //      margin-right: 0;
        margin-top: 0;
        padding: 0;
        padding-top: 0;
        border: 0;
      }
    }
  `}
  */

  ${props => props.borderTop && `
    border-top: 1px solid ${colors.GRAY_LIGHT} !important;
    margin-left: -4.5rem !important;
    margin-right: -3rem !important;
    padding: 1rem 3rem !important;
  `}

`;

class Accordion extends Component {
  state = {
    open: false,
  }

  onClick = () => {
    const { open } = this.state;
    this.setState({
      open: !open,
    });
  }

  render() {
    const {
      Header = 'header',
      Container = 'section',
      className = '',
      renderHeaderContent,
      borderTop,
      toggleDisabled,
      children,
    } = this.props;

    const wrapperClass = classnames(className, 'accordion', {
      'open': this.state.open,
    });

    const headerClass = classnames({
      'open': this.state.open,
      'toggleDisabled': toggleDisabled,
    });

    return (
      <Wrapper className={wrapperClass} Container={Container} borderTop={borderTop}>
        <Header onClick={!toggleDisabled && this.onClick} className={headerClass}>
          {renderHeaderContent()}
        </Header>
        <Container>
          {children}
        </Container>
      </Wrapper>
    );
  }
}

export default Accordion;


// WEBPACK FOOTER //
// ./src/modules/common/components/Accordion.js